import HeaderFooter from './components/page/common/HeaderFooter'

const headerFooter = {
    install: function(Vue) {
        Vue.component('headerFooter', HeaderFooter)
    }
}
export default headerFooter


// WEBPACK FOOTER //
// ./src/components.js